import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { authActions } from "../../_store";
import { showToastNotification } from "../../components/common/ui/NotificationModal/ToastNotication";
import CustomLoader from "../../components/common/ui/Loader";
import Logo from "../../assets/Broward-Partnerships-for-kids-logo.png";
import { useNavigate } from "react-router-dom";
import { history } from "../../_helpers";
import Button from "../../components/common/ui/Button";
import { PasswordInput } from "../../components/common/ui/Inputs";
import resetPasswordSchema from "../../validation/resetPasswordSchema";
import { encryptData } from "../../utils/encryptDecrypt";

function AdminResetPassword() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState({});
  const [submit, setSubmit] = useState(false);
  const resetPasswordResponse = useSelector(
    (state) => state.auth.resetPasswordResponse
  );
  const [token, setToken] = useState("");
  const [password, setPassword] = useState({
    password: "",
    confirmPassword: "",
  });

  useEffect(() => {
    const url = window.location.href;
    const extractedToken = url.split("/").pop();
    setToken(extractedToken);
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e?.target;
    setPassword((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const restrictCharacters = (e, restrictedChars = ["'", "`"]) => {
    if (restrictedChars.includes(e.key)) {
      e.preventDefault(); // Prevent the restricted character from being entered
    }
  };

  const togglePasswordVisibility = (type) => {
    type === "password"
      ? setShowPassword((prev) => !prev)
      : setShowConfirmPassword((prev) => !prev);
  };

  // Forgot Password - submit function
  const handleSubmit = async (event) => {
    event.preventDefault();

    setErrorMessage({});
    setSubmit(true);
    const { error } = resetPasswordSchema(password);
    if (error?.details) {
      setSubmit(false);
      error?.details?.map((e) => {
        const { path } = e;
        setErrorMessage((prev) => ({
          ...prev,
          [path[0]]: e?.message,
        }));
      });
      return;
    }
    const encryptPassword = encryptData(password?.password);
    const encryptconfirmPassword = encryptData(password?.confirmPassword);

    dispatch(
      authActions.resetPassword({
        token,
        newPassword: encryptPassword,
        confirmPassword: encryptconfirmPassword,
      })
    )
      .then((result) => {
        setSubmit(false);
        if (result?.payload?.status === 1) {
          showToastNotification(result?.payload?.message, "success");
          setSubmit(false);
          navigate("/Admin/login");
        } else {
          showToastNotification(result?.error?.message, "error");
        }
      })
      .catch((err) => {
        showToastNotification("Failed to reset password", "error");
        setSubmit(false);
      });

    setSubmit(false);
    handleReset();
  };

  // Handle reset action
  const handleReset = () => {
    setErrorMessage({});
    setPassword({
      password: "",
      confirmPassword: "",
    });
  };
  // Function for navigate login page
  const handleClickLogin = () => {
    history?.navigate("/Admin/login");
  };

  // Function for navigate regsiter page
  const handleSignUp = () => {
    navigate("/register");
  };

  // if (loader) {
  //   return <CustomLoader />;
  // }
  return (
    <>
      <section className="sign-in-section admin-login-banner">
        <span className="sr-only" role="img" aria-label="Admin Reset Password Page"></span>
        <div className="container">
          <div className="row justify-content-center align-items-center authentication authentication-basic h-100">
            <div className="col-xxl-5 col-xl-5 col-lg-5 col-md-6 col-sm-8 col-12">
              <div className="admin-login-container custom-card my-4">
                <div className="card-body p-5">
                  <div className="mb-3 d-flex justify-content-center">
                    <img
                      className="Sidebarlogo"
                      src={Logo}
                      alt="small-logo"
                    ></img>
                  </div>
                  <h2 className="mb-4 text-left">Reset Password</h2>

                  <form onSubmit={handleSubmit}>
                    <p className="font-size-16">Enter a new password below.</p>
                    <div className="mb-4">
                      <label for="username" className="form-label">
                        New Password<span className="text-danger">*</span>
                      </label>

                      <PasswordInput
                        name="password"
                        ariaLabel="Password"
                        id="password"
                        onKeyDown={(e) => restrictCharacters(e)}
                        value={password?.password}
                        handleChange={handleInputChange}
                        placeholder="New Password"
                        required={true}
                        errorMessage={errorMessage}
                        showPassword={showPassword}
                        togglePasswordVisibility={() =>
                          togglePasswordVisibility("password")
                        }
                        autoComplete="new-password"
                        maxlength={25}
                      />
                    </div>
                    <div className="mb-4">
                      <label for="username" className="form-label">
                        Confirm Password<span className="text-danger">*</span>
                      </label>

                      <PasswordInput
                        name="confirmPassword"
                        id="confirmPassword"
                        onKeyDown={(e) => restrictCharacters(e)}
                        value={password?.confirmPassword}
                        handleChange={handleInputChange}
                        placeholder="Confirm Password"
                        required={true}
                        errorMessage={errorMessage}
                        showPassword={showConfirmPassword}
                        togglePasswordVisibility={() =>
                          togglePasswordVisibility("confirm")
                        }
                        autoComplete="new-password"
                        maxlength={25}
                        ariaLabel="Confirm Password"
                      />
                    </div>

                    <div className="d-flex justify-content-center align-items-center gap-2">
                      <Button
                        status="green"
                        type="submit"
                        label="Submit"
                        disabled={submit}
                      />
                      <Button
                        status="reset"
                        label="Reset"
                        type="reset"
                        onClick={handleReset}
                      // disabled={true}
                      />
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default AdminResetPassword;
